export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'PHOTOS_SET':
      return payload
    case 'PHOTO_CREATE':
      return [payload, ...state]
    case 'PHOTO_GET':
      return state.map(item => (item.id === payload.id ? payload : item))
    case 'PHOTO_UPDATE':
      return state.map(item => (item.id === payload.id ? payload : item))
    case 'PHOTO_DELETE':
      return state.filter(item => item.id !== payload)
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
